export default {
  language: {
    name: "English"
  },

  // 顶部菜单、底部菜单 公共组件
  home: {
    index: "首页",
    products: "产品",
    application: "应用",
    enterpriseNews: "新闻资讯",
    aboutUS: "关于我们",
    aboutRJ: "关于瑞杰",
    joinUs: "加入我们",
    callUs: "联系我们",
    rjActive: "瑞杰动态",
    industryNews: "行业新闻",
    exit: "退出",
    shoppingCart: "购物车",
    loginRegistration: "登陆/注册"
  },
  // 登录/注册页
  loginAndRegister: {
    mobileQuickLogin: "手机快捷登录",
    accountLogin: "账号登录",
    placeholder1: "请输入11位手机号码",
    placeholder2: "请输入手机验证码",
    placeholder3: "请输入手机号",
    placeholder4: "请设置密码",
    placeholder5: "请输入验证码",
    sendVerificationCode: "发送验证码",
    retrieve: "重新获取",
    logOn: "登录",
    clickingToLogInMeansYouAgree: "点击登录意味着您同意",
    userRegistrationAgreement: "用户协议",
    privacyPolicy: "隐私权政策",
    otherLoginMethods: "其他登录方式",
    password: "密码",
    automaticLogon: "自动登录",
    freeRegistration: "免费注册",
    forgotPassword: "忘记密码？",
    register: "注册 ",
    registering: "正在注册",
    existingAccountLogInNow: "已有账号，立即登录",
    loggingIn: "正在登录",
    obtainVerificationCode: "获取验证码",
    iHaveReadAndAgree: "我已阅读并同意",
    close: "关闭",
    seconds: "秒",
    //移动端
    mobileAccountLogin: "手机账号登陆",
    accountPasswordLogin: "账号密码登录",
    pleaseEnterPassword: "请输入密码",
    signUpNow: "立即注册",
    smsLogin: "手机短信登录",
    mobileText1: "瑞杰创新欢迎你!",
    mPlaceholder1: "请输入用户账号",
    mPlaceholder1: "请再次输入用户密码",
    clickingRegisterMeansYouAgree: "点击注册意味着您同意"
  },
  // 首页
  index: {
    applicationUse: "产品应用",
    callUs: "联系我们",
    aboutRJ: "关于瑞杰",
    more: "查看更多",
    companyYear: "公司成立",
    companyPerson: "研发人员",
    companyCustom: "公司客户",
    placeholderUserName: "请输入您的姓名",
    placeholderCompanyName: "请输入公司名称",
    placeholderUserPhone: "请输入手机号码",
    placeholderRemark: "请输入备注",
    formSubmit: "提交",
    companyProfile: "公司介绍"
  },

  // 产品分类页面
  products: {
    all: "全部",
    totel: "共",
    piece: "件",
    yuan: "元"
  },

  // 产品信息页面
  productInfo: {
    products: "产品信息",
    applicationDescription: "应用说明",
    productManual: "产品说明书",
    download: "下载 ",
    details: "详情介绍",
    buyNOW: "立即购买",
    addToShoppingCart: "加入购物车",
    contactUs: "联系我们",
    price: "商城价",
    selectType: "选择类型",
    submit: "提交 ",
    ruijieInnovation: "瑞杰创新",
    // 移动端
    service: "服务",
    providedByRuijieForTechnicalSupportServices: "由瑞杰提供技术支持服务",
    select: "选择",
    purchaseQuantity: "购买数量",
    selectPpecifications: "选择规格"
  },
  // 新闻资讯页面
  enterpriseNews: {
    enterpriseNews: "新闻资讯",
    menuItem1: "瑞杰动态",
    menuItem2: "行业新闻"
  },

  // 新闻详情页面
  newConent: {
    index: "首页",
    menuItem1: "瑞杰动态",
    menuItem2: "行业新闻"
  },

  // 关于我们
  aboutUS: {
    aboutUS: "关于我们",
    aboutRj: "关于瑞杰",
    joinUs: "加入我们",
    callUs: "联系我们",
    aboutUSItem: {
      tab1Name: "公司简介",
      tab2Name: "发展历程",
      tab3Name: "技术实力",
      tab4Name: "生产能力",
      tab5Name: "合作伙伴",
      tab6Name: "企业文化",
      tab1Text1: "   瑞杰创新科技致力于无人机、机器人、智能设备配件的引领者",
      tab1Text2: `深圳市瑞杰创新科技有限公司是一家专注于提供机器人零部件解决方案的高科技型企业。核心研发人员从业多年以及有一定的技术积累;
                  公司在GNSS定位、无刷电机控制、激光测距、智能电池技术,相机图传,云台,数据传输等领域取得一定技术成果,产品在行业内取得一定市场份额。
                  公司立志于为机器人行业快速发展提供安全,可靠,性价比高的零部件；并使机器人产品可平台化、模块化。`,
      tab1Text3: `我们坚持极客精神设计和开发产品,坚持“以用户为中心，以奋斗者为本
                  ”的核心经营理念，坚持“艰苦奋斗，团结合作，荣辱与共，永不放弃”的
                  团队精神，坚持“诚信，责任，激情，奉献，思考，创新”的核心价值观。`,

      tab2Text1: `老产品稳定出货的同时,新项目持续完善,智能电池项目、RTK项目、数传项目陆续进入试产和小批量量产。同年公司继续加大研发投入,成立相机图传APP专案项目组,进入机器人图像视觉和传输领域;并和多家芯片原厂达成战略合作。`,
      tab2Text2: `GNSS定位模组、激光测距模组,无刷电机控制板,三驾马车并驾齐驱,不断迭代。公司实现产品多元化的同时,积极扩充人才,新增测试设备,完善产品流程,强化公司产品品质；
                  同步继续创新,智能电池管理+快充项目、RTK固定站+移动站项目、数据传输项目等相继立项开发。`,
      tab2Text3: `激光测距模组和电机控制板的成功,使得公司在创新的道路上尝到甜头,同年激光测距模组实现10万+的出货量,电机控制板实现40万+的出货量;同年RTK项目立项并实现量产出货。`,
      tab2Text4: `经过多年的客户积累和市场深耕,结合市场需求，同年初开发激光测距模块，为无人机机器人等产品增加避障功能，年底激光测距模块实现量产；同年年底开发出无刷电机控制板，解决行业长期成本较高，性能不足等痛点。`,
      tab2Text5: `经过三年的客户积累和市场深耕，结合市场需求，开发；激光避障模块，为无人机增加避障功能，年底实现量产`,
      tab2Text6: `GPS产品继续扩大市场份额，针对不同客户需求，配置不同软件，使得我司产品和客户黏性增加，同年也实现扭亏为盈`,
      tab2Text7: `瑞杰创新2015年11月份正式成立,直至2019年,公司一直深耕GNSS定位模块,针对不同客户需求,配置不同软件,使得我司产品和客户黏性增加,并取得较大市场占有率。`,
      tab2Text8: `年`,
      tab2Text9: `继续加大研发投入,云台项目和安卓遥控器项目进入立项开发。2024年公司目标: GNSS定位模组、激光测距模组,无刷电机控制板等持续迭代,并扩大出货量;智能电池项目、RTK项目、数传项目实现大批量出货;相机图传AP项目实现批量出货。`,

      tab3Text1: `技术引领性`,
      tab3Text2: `首创无人机激光避障模式`,
      tab3Text3: `瑞杰创新开发的R20激光模组，首创在无人机上替代视觉避障，大大降低无人机成本。`,
      tab3Text4: `多款GPS应用于无人机`,
      tab3Text5: `无人机对GPS的要求比较特殊，瑞杰开发的多款GPS模组应用于无人机市场，给客户省去繁重的开发工作量。`,
      tab3Text6: `无刷电机电调效率高`,
      tab3Text7: `对比同行的无刷电机电调，瑞杰创新电调效率提高了15%-20%的效率。`,
      tab3Text8: `电池快充板`,
      tab3Text9: `电池快充保护板实现比同类型产品充电效率提升一个台阶，性价比提升20%。`,
      tab3Text10: `首创国产GPS实现在无人机上应用`,
      tab3Text11: `美国对华半导体的封杀，导致进口
          GPS芯片的缺货，瑞杰首先配合国
          产GPS芯片调试无人机应用的GPS
          模组，并且成功实现量产化`,
      tab3Text12: `技术先进性`,
      tab3Text13: `安全性、稳定性`,
      tab3Text14: `精度控制能力强`,
      tab3Text15: `系统集成与自动化 能力突出`,
      tab3Text16: `节能性能优异`,
      tab3Text17: `六大事业部`,
      tab3Text18: `GPS模组开发部`,
      tab3Text19: `通用型GPS模组 RTK高精度GPS 惯性导航算法 无人机应用算法`,
      tab3Text19_mobile: `通用型GPS模组
        RTK高精度GPS
        惯性导航算法
        无人机应用算法`,
      tab3Text20: `激光模组部`,
      tab3Text21: `单点不可见光激光
          360度扫描激光
          单点带角度输出激光
          雷达激光测距`,
      tab3Text22: `无刷电机电调部`,
      tab3Text23: `无人机电调
          无刷船电调（正反转）
          穿越机电调
          高速车电调`,
      tab3Text24: `综合部`,
      tab3Text25: `机动综合部门`,
      tab3Text26: `云台部`,
      tab3Text27: `无刷云台
        图片传输`,
      tab3Text28: `电池智能快充部`,
      tab3Text29: `电池智能板
        电池快充板
        一拖三快充适配器`,
      tab3Text30: `核心价值观`,
      tab3Text31: `责任 诚信 创新 思考 奉献 激情`,
      tab3Text32: `
          诚信铸就品质 创新赢得市场
          我们始终坚持诚信履约，品质求胜的思想；以敢于创新的精神，推进企业发展，赢得市场。
          以人为本 求质量 重信誉
          注重环境保护、能源节约、毕业生就业等社会工作。`,
      tab3Text33: `未来展望`,
      tab3Text34: `新机遇 新市场 新技术 新产品 新价值`,
      tab3Text35: `共同努力 上下一心 艰苦奋斗
          同舟共济 全力拼搏 共创辉煌。`,
      tab3Text36: `团队精神`,
      tab3Text37: `艰苦奋斗 团队合作 荣辱与共 永不言弃`,
      tab3Text38: `艰苦奋斗：弘扬艰苦奋斗精神,发扬艰苦奋斗传统,保持艰苦奋斗境界,坚持艰苦奋斗的价值取向,是企业发展的核心动力。
          团结合作：团结就是力量,成功在于合作；团结合作精神是创业之基,兴业之本。
          荣辱与共：在企业的生死存亡的关头也誓与企业荣辱与共的精神,是企业之源泉。
          永不放弃：永不放弃，永不低头，持续学习，提升企业软实力。`,
      tab3Text39: `企业使命`,
      tab3Text40: `
          立志于为无人机机器人行业快速发展提供安全，可靠，性价比高的零部件；
          并使无人机机器人产品可平台化、模块化创建国际一流的技术创新型公司`,
      tab3Text41: `企业精神`,
      tab3Text42: `以人为本 视质量为生命`,
      tab3Text43: `研发团队规模`,
      tab3Text44: ``
    },
    joinUsItem: {
      tab1Name: "人才理念",
      tab2Name: "员工福利",
      tab3Name: "员工风采",
      tab4Name: "职位申请",

      tab1Row1Tit: "唯才是用，唯德重用",
      tab1Row1Text:
        "人才是第一资源。“生产一流产品， 创造一流企业“离不开”培养一流 人才，建设一流团队“。 公司始终坚持唯才是用、唯德重用，有德有才 者，破格 重用；无才无德者，坚决不用。",
      tab1Row2Tit: "人尽其才，才尽其用",
      tab1Row2Text:
        "坚持“让专业的人做专业的事“，不断 完善人才管理体制、评价机制、激励机制和流动机制，优秀 人才能力有多大，舞台就有多大。",
      tab1Row3Tit: "共同发展，共享成功",
      tab1Row3Text: "员工与企业共同成长、共同发展、共享成功。",

      tab2Row1Name: "培训体系建设之资源层建设",
      tab2Row2Name: "培训体系建设的构成",
      tab2Row3Name: "培训机会",
      tab2Row1Text1: "新员工引导培训",
      tab2Row1Text2: "企业简介",
      tab2Row1Text3: "企业发展史",
      tab2Row1Text4: "企业文化",
      tab2Row1Text5: "企业相关制度",
      tab2Row1Text6: "工作流程",

      tab2Row1Text7: "基础岗位技能培训",
      tab2Row1Text8:
        "根据岗位胜任能力确定的基础性培训课程，从事各类各级岗位需掌握的应知应会知识和技能。岗位调动、职位晋升、绩效考核反应知识技能有欠缺者，都需要根据任职资格及个人能力，进行岗位技能课程培训。",
      tab2Row1Text9: "岗位技能提升课程",
      tab2Row1Text10:
        "根据科技、管理等发展动态，结合企业发展目标和竞争战略做出培训分析后确立的动态培训课程。",
      tab2Row1Text11: "员工个人成长培训课程",
      tab2Row1Text12:
        "根据员工的职业生涯规划，当员工需要提升的时候进行的培训课程。",

      tab2Row2Text1: `资源层面`,
      tab2Row2Text2: `内部讲师队伍`,
      tab2Row2Text3: `培训课程体系`,
      tab2Row2Text4: `培训资料库`,
      tab2Row2Text5: `员工培训档案`,
      tab2Row2Text6: `运作层面`,
      tab2Row2Text7: `培训需求`,
      tab2Row2Text8: `培训计划与预算`,
      tab2Row2Text9: `培训组织与实施`,
      tab2Row2Text10: `培训考核与评估`,
      tab2Row2Text11: `制度层面`,
      tab2Row2Text12: `培训管理系统`,
      tab2Row2Text13: `培训的制度与流程`,
      tab2Row2Text14: `现代企业的竞争是“人才”的竞争，随着知识和技术的更新速度
        加快，企业和员工均需要以积极主动的心态迎接“终身学习”时
        代的到来。公司为员工提供全方位的立体式培训体系，让新员
        工快速融入团队、熟悉本职工作并不断搞自身素质。`,

      tab3Text1: `参观机器人`,
      tab3Text2: `参观机器人小镇活动`,

      tab4Text1: `招聘岗位`,
      tab4Text2: `所属部门`,
      tab4Text3: `发布日期`,
      tab4Text4: `操作`,
      tab4Text5: `申请`,
      tab4Text6: `详情`,
      tab4Text7: `申请职位`,
      tab4Text8: `姓名`,
      tab4Text9: `请输入姓名`,
      tab4Text10: `手机号码`,
      tab4Text11: `请输入手机号码`,
      tab4Text12: `上传简历`,
      tab4Text13: `支持Doc、Excal、PDF、PNG、Jpg格式简历文件, 且大小不超过5MB`,
      tab4Text14: `提交`,
      tab4Text15: `立即申请`,
      tab4Text16: `职位申请`
    },
    callUsItem: {
      text1: "深圳市瑞杰创新科技有限公司",
      text2: "Shenzhen Extreme Power Technology Incorporated Company",
      text3: "地址:深圳市宝安区新安街道创业二路东联大厦B309",
      text4: "邮编:518000",
      text5: "深圳总部",
      text6: "电话:0755-2350 2257, 0755-2350 2189",
      //text7: "手机：13612958273(黄先生)",
      //text8: "8320800981(刘先生)",
      text7: "手机:13714999515(章先生)",
      text8: "13612958273(黄先生)",
      text13: "17552314320(李先生)",
      text9: "华南代理",
      text10: "电话:021-6029 9378",
      text11: "手机:18521798797(凌先生)",
      text12: "邮箱:ledey@shphtec.com",
      "华东分公司地址": "华东分公司地址",
      "地址: 上海青浦区沪青平公路3908号智创天地422/428室": "地址: 上海青浦区沪青平公路3908号智创天地422/428室"
    }
  },
  // 购物车
  shoppingCar: {
    myart: "我的购物车",
    SelectAll: "全选",
    commodityInformation: "商品信息",
    unitPrice: "单价",
    number: "数量 ",
    subtotal: "小计",
    operate: "操作",
    theShoppingCartDoesnHaveAnyProductsYetHurryUpAndMakeApurchase:
      "购物车还没有商品，赶紧选购吧!",
    goforAstroll: "去逛逛",
    selectedProduct: "已选商品",
    piece: "件",
    amountTo: "合计",
    nextStep: "下一步",
    yuan: "元",
    shoppingCarTitle: "商城_购物车",
    // 移动端
    shoppingCart: "购物车",
    shoppingText: "您的购物车还是空的",
    goSettle: "去结算",
    delete: "删除",
    edit: "编辑",
    complete: "完成"
  },

  // 订单中心
  submitOrders: {
    submitOrdersTitle: "订单_提交订单",
    orderingInformation: "订单信息",
    address: "收货地址",
    default: "默认 ",
    addNewAddress: "添加新地址",
    InvoiceInformation: "发票信息",
    modify: "修改 ",
    orderNotes: "订单备注",
    commodityInformation: "商品信息",
    unitPrice: "单价",
    number: "数量 ",
    subtotal: "小计",
    distributionCosts: "配送费用 ",
    payableAmount: "应付金额",
    submitOrder: "提交订单",
    invoiceInformation: "发票信息",
    invoiceType: "发票类型",
    notInvoicing: "不开发票 ",
    personalElectronicInvoice: "个人电子发票",
    companyElectronicInvoice: "公司普通发票",
    specialInvoice: "公司专用发票",
    addressC: "公司地址",
    phone: "公司电话",
    bank: "公司开户行",
    bankAccount: "公司银行账号",
    mailbox: "邮箱 ",
    invoiceHeader: "发票抬头",
    taxIdentificationNumber: "纳税识别号",
    invoiceContentPurchaseItemDetails: "发票内容: 购买商品明细 ",
    submitOrdersText1:
      "电子发票将在您提交后的3-5个工作日内发送到您的电子邮箱,请您注意查收",
    invoicerelatedinformation: "发票相关信息",
    submitOrdersText2: "增值发票请联系在线客服",
    cancellation: "取消 ",
    determine: "确定 ",
    name: "姓名",
    phoneNumber: "手机号",
    zipCode: "邮编",
    District: "所属地区",
    FullAddress: "详细地址",
    street: "街道",
    setAsDefaultShippingAddress: "设为默认收货地址",
    Address: "收货地址",
    taxNumber: "纳税识别号",
    edit: "修改",
    add: "新增",
    edit: "修改",
    deleteTheAddress: "删除该地址",
    placeholder1: "请填写收货人姓名",
    placeholder2: "请填写收货人手机号",
    placeholder3: "填写邮政编号",
    placeholder4: "请填写收货详细地址",
    placeholder5: "请填写街道名称",
    placeholder6: "填选，请先和商家协商一致",
    placeholder7: "请输入邮箱账号",
    placeholder8: "请输入发票抬头",
    placeholder9: "请填写购买纳税人识别号或同一社会信用代码",
    placeholder10: "请输入您的企业地址",
    placeholder11: "请输入公司电话",
    placeholder12: "请输入开户银行名称",
    placeholder13: "请输入公司银行账户",
    messageTitle1: "未输入邮箱账号或邮箱账号格式不对",
    messageTitle2: "未输入发票抬头或发票抬头格式不对",
    messageTitle3: "请填写购买纳税人识别号或同一社会信用代码或格式不正确",
    messageTitle4: "未输入公司地址或公司地址格式不对",
    messageTitle5: "未输入公司电话或公司电话格式不对",
    messageTitle6: "未输入公司开户行或公司开户行格式不对",
    messageTitle7: "未输入公司银行账号或公司银行账号格式不对",
    invoice: {
      个人电子发票: "个人电子发票",
      公司普通发票: "公司普通发票",
      公司专用发票: "公司专用发票",
      不开发票: "不开发票"
    },

    // 移动端
    editOrder: "编辑订单",
    coupons: "优惠券",
    freightCharge: "运费",
    offers: "优惠",
    invoiceM: "发票",
    buyersMessage: "买家留言",
    writeDownYourSpecialRequirements: "写下您的特殊要求",
    contactCustomerService: "联系客服",
    submit: "提交",
    noCouponAvailable: "暂无可使用的优惠券",
    total: "合计",
    selectAddress: "选择地址",
    aTotalOf: "共",
    pieces: "件",
    email: "电子邮箱",
    mText1: "填写发票信息",
    mText2: "选择发票类型",
    mPlaceholder1: "请输入邮箱地址",
    mPlaceholder2: "请输入纳税识别号"
  },
  //  移动端订单详情
  orderDetails: {
    invoiceDetails: "发票详情",
    invoiceType1: "发票类型: 不开发票",
    invoiceType2: "发票类型: 个人电子发票",
    invoiceType3: "发票类型: 公司普通发票",
    invoiceType4: "发票类型: 公司专用发票",
    email: "电子邮箱",
    taxNumber: "纳税识别号",
    companyAddress: "公司地址",
    phone: "公司电话",
    bank: "公司开户行",
    bankAccount: "公司银行账号",
    orderText: "还未发货，找不到快递单号"
  },
  // 个人资料
  userpersonalData: {
    modifiedSuccessfully: "修改成功",
    cancellation: "取消",
    personalData: "个人资料",
    dataCompleteness: "资料完整度",
    medium: "中等",
    basicInformation: "基本信息",
    userName: "用户名",
    gender: "性别 ",
    male: "男 ",
    female: "女",
    location: "所在地",
    address: "地址",
    save: "保存 ",
    modifyAvatar: "修改头像",
    selectFile: "选择文件",
    uploadFiles: "上传文件",
    userpersonalDataText1: "jpg或png,大小不超过2M",
    noFileSelected: "未选择任何文件",
    placeholder5: "请输入您的尊称",
    placeholder6: "请选择您所在的行政区域",
    placeholder7: "请先选取图片",
    placeholder8: "上传文件大小不能超过2M"
  },

  // 我的账号
  myAccount: {
    personalInformation: "个人信息",
    hereYouCanViewPersonalInformation: "这里可以查看个人信息",
    editProfile: "修改个人资料",
    aCCOUNT: "我的账户",
    security: "账户安全",
    membershipLevel: "会员等级",
    bindPhone: "绑定手机",
    bindNow: "立即绑定",
    exit: "退出 "
  },

  // 我的订单
  myOrders: {
    myOrder: "我的订单",
    search: "搜索",
    allOrders: "全部订单",
    obligation: "待付款",
    toBeReceived: "待收货",
    toBeEvaluated: "待评价",
    orderNumber: "订单编号",
    productNameProductNumberOrderNumber: "商品名称、商品编号、订单编号",
    coProducts: "共商品",
    piece: "件",
    total: "合计",
    goMakeThePayment: "去付款",
    orderDetails: "订单详情",
    cancellationOfOrder: "取消订单",
    confirmReceipt: "确认收货",
    determine: "确定",
    cancellation: "取消",
    myOrdersText1: "确定要删除此订单数据吗？",
    statusTest: {
      待付款: "待付款",
      待收货: "待收货",
      "已付款（待发货）": "已付款（待发货）",
      "已收货（待评价）": "已收货（待评价）",
      已评价: "已评价"
    },
    // 移动端
    whole: "全部",
    completeOrder: "完成订单",
    regularStyle: "普通款 ",
    order: "订单",
    closeOrder: "取消订单",
    payment: "立即支付",
    noOrder: "暂无订单",
    common: "共",
    gettingYourOrderData: "正在获取您的订单数据...",
    evaluateNow: "立即评价",
    deleteOrder: "删除订单",
    全部: "全部",
    待付款: "待付款",
    待收货: "待收货",
    待评价: "待评价",
    完成订单: "完成订单",
    充值: "充值"
  },

  // 我的收藏
  myCollection: {
    myCollection: "我的收藏",
    search: "搜索",
    commodityInformation: "商品信息",
    price: "价格",
    operate: "操作",
    collectionTime: "收藏时间",
    bUYNOW: "立即购买",
    cancelFavorite: "取消收藏",
    youHaventCollectedAnyProductsYet: "您还没有收藏任何商品",
    goForAStroll: "去逛逛",
    productNameAndProductNumber: "商品名称、商品编号"
  },
  // 安全中心
  securityCenter: {
    securityCenter: "安全中心",
    securityLevel: "安全级别",
    securityCenterText1: "建议您开启全部安全设置，以保障账户及资金安全",
    loginPassword: "登录密码",
    securityCenterText2: "请经常更换您的登录密码，且不要和其他账号共用一个密码",
    securityCenterText3:
      "进行手机验证后，可以用户快速找回账号密码和身份验证操作，保护您的账号安全，以及及时获取订单发货等通知类信息",
    securityCenterText4:
      "为保障您的账户信息安全，在变更账户中得重要信息时需要进行身份验证，感谢您的理解和支持！已验证手机可用于账户余额变动提醒",
    modify: "修改",
    mobileVerification: "手机验证",
    verifyNow: "立即验证",
    changePassword: "修改密码",
    originalPassword: "原密码",
    obtainVerificationCode: "获取验证码",
    newPassword: "新密码",
    inGeneral: "一般",
    complete: "完成",
    placeholder1: "请输入原密码",
    placeholder2: "请输入验证码",
    placeholder3: "请设定您的新密码",
    placeholder4: "请再次输入新密码",
    placeholder5: "请输入您的手机号码"
  },

  // 收货地址
  address: {
    address: "收货地址",
    addShippingAddress: "新增收货地址",
    youHaveCreated: "您已创建 ",
    shippingAddress: "个收货地址",
    upTo5CanBeCreated: "最多可创建5个 ",
    default: "默认 ",
    addButtinText: "新增地址",
    name: "姓名",
    phoneNumber: "手机号",
    zipCode: "邮编",
    district: "所属地区",
    fullAddress: "详细地址",
    street: "街道",
    setAsDefaultShippingAddress: "设为默认收货地址",
    placeholder1: "请填写收货人姓名",
    placeholder2: "请填写收货人手机号",
    placeholder3: "填写邮政编号",
    placeholder4: "请填写收货详细地址",
    placeholder5: "请填写街道名称",
    edit: "修改",
    deleteTheAddress: "删除该地址",
    add: "新增",
    // 移动端
    addressManagement: "地址管理",
    consignee: "收货人",
    mPlaceholderM1: "请填写收货人姓名",
    mPlaceholderM2: "请填写收货人手机号",
    mPlaceholderM3: "请填写街道名称",
    mPlaceholderM4: "请填写收货详细地址",
    cellPhoneNumber: "手机号",
    provincesCitiesDistricts: "省市区",
    street: "街道",
    address: "详细地址",
    isItDefault: "是否默认",
    addressTitle1: "你还没添加收货地址",
    addressTitle2: "确认删除该地址吗？",
    addressTitle3: "请选择省市区",
    addressTitle4: "新增收货地址",
    addressTitle5: "编辑收货地址",
    submit: "提交",
    delete: "删除"
  },
  // 个人中心
  userPersonal: {
    homePage: "首页",
    personalCenter: "个人中心",
    orderCenter: "订单中心",
    myAccount: "我的账号",
    myOrder: "我的订单",
    myCollection: "我的收藏",
    account: "账户管理",
    personalData: "个人资料",
    securityCenter: "安全中心",
    address: "收货地址",
    aboutRuijie: "关于瑞杰",
    agreement: "使用协议",
    myAccountTitle: "瑞杰商城_我的账号",
    myOrderTitle: "瑞杰商城_我的订单",
    myCollectionTitle: "瑞杰商城_我的收藏",
    agreementTitle: "瑞杰商城_使用协议",
    personalCenterTitle: "个人中心_个人资料",
    securityCenterTitle: "个人中心_安全中心",
    addressManagementTitle: "个人中心_地址管理",
    pageName: {
      我的账号: "我的账号",
      我的订单: "我的订单",
      我的收藏: "我的收藏",
      个人资料: "个人资料",
      安全中心: "安全中心",
      收货地址: "收货地址",
      使用协议: "使用协议"
    },
    // 移动端
    accountSettings: "账户设置",
    personalData: "个人资料",
    headSculpture: "头像",
    nickname: "昵称",
    personalSignature: "个性签名",
    gender: "性别",
    location: "所在地",
    birthday: "生日",
    accountSecurity: "账号安全",
    bindPhone: "绑定手机",
    logOutAndLogIn: "退出登录",
    exit: "退出",
    save: "保存",
    newNickname: "新昵称",
    cancel: "取消",
    pleaseSelectRegion: "请选择行政区",
    fullAddress: "详细地址",
    changeTheName: "更改名称",
    man: "男",
    female: "女",
    comfirm: "确认",
    logOut: "退出登陆",
    settingAddressInformation: "设定地址信息",
    mPlaceholder1: "好的昵称可以更突出你的style",
    mPlaceholder2: "选择您的性别",
    mPlaceholder3: "请填写详细地址",

    "我的设备": "我的设备",
    "飞行记录": "飞行记录",
    mText1: "您已绑定手机号，如需解除绑定可前往个人中心解绑",
    mText2: "该操作会退出当前登录状态，并清除页面缓存，要继续吗？"
  },
  // 移动端个人中心
  persionCenter: {
    my: "我的",
    myOrder: "我的订单",
    viewAllOrders: "查看全部订单",
    obligation: "待付款",
    toBeShipped: "待发货",
    toBeReceived: "待收货",
    openForComment: "待评论",
    refundPayment: "退货款",
    address: "收货地址",
    customerServiceTelephoneNumbers: "客服电话",
    mondayToSunday: "周一至周日8:00-24:00"
  },
  // 订单详情
  orderStep: {
    orderTracking: "订单追踪",
    OrderNumber: "订单编号 ",
    OrderTime: "下单时间",
    CurrentOrderStatus: "当前订单状态",
    OrderCreatedSuccessfully: "订单创建成功！",
    orderDetails: " 订单详情",
    consigneeInformation: " 收货人信息",
    consignee: " 收货人",
    address: " 地址",
    phoneNumber: " 手机号码",
    invoiceHeader: " 发票抬头",
    buyerMessage: " 买家留言",
    paymentMethodsAndLogistics: " 支付方式和物流",
    commodityList: " 商品清单",
    photographTheMerchandise: "拍下商品",
    payment: "付款",
    shippingConfirmingReceipt: "发货/确认收货",
    evaluation: "评价",
    orderStepText1: "买家已经付款，订单",
    orderStepText2: "卖家已发货，快递单号",
    logisticsCompany: "物流公司",
    logisticsInquiry: "物流查询",
    orderCancelled: "订单已取消",
    yuan: "元",
    cancelAnOrder: "取消订单",
    expressDeliveryMethod: "快递方式",
    invoiceInformation: "发票信息",
    orderType1: "发票类型: 不开发票",
    orderType2: "发票类型: 个人电子发票",
    orderType3: "发票类型: 公司普通发票",
    orderType4: "发票类型: 公司专用发票",
    orderStatusText: {
      全部: "全部",
      待付款: "待付款",
      待发货: "待发货",
      待收货: "待收货",
      待评价: "待评价",
      完成订单: "完成订单",
      已完成: "已完成",
      取消订单: "取消订单",
      我的账号: "我的账号",
      无效订单: "无效订单"
    },
    // 移动端
    status: "订单状态",
    trackingNumber: "快递单号",
    clickToViewLogistics: "点击查看物流",
    payment: "支付",
    paymentMethod: "支付方式",
    productAmount: "商品金额",
    coupon: "优惠券",
    payableAmount: "应付金额"
  },
  // 付款页面
  payment: {
    paymentTitle: "商城_支付",
    paymentText1: "订单提交成功，请您尽快付款！",
    paymentText2: "请您在提交订单后24小时内完成支付,否则订单会自动取消。",
    payableAmount: "应付金额 ",
    paymentMethod: "支付方式",
    queryOrders: "查询订单 ",
    keepShopping: "继续购物",
    scanToPay: "扫码支付",
    sweepThePayment: "扫一扫付款",
    pleaseUseAlipayToScanIt: "请使用支付宝扫一扫",
    pleaseUseWechatToScanIt: "请使用微信扫一扫",
    payByScanningTheQRCode: "扫描二维码支付",

    resultOfRayment: "支付结果",
    youHaveSuccessfullyPaid: "您已成功付款",
    yuan: "元",
    viewPurchasedItems: "查看已购买商品",
    paymentFailure: "支付失败",
    pleaseReinitiateThePayment: "请您重新发起支付",
    nameOfCommodity: "商品名称",
    repay: "重新支付",
    payBtnText: {
      去付款: "去付款",
      待付款: "待付款",
      订单完成: "订单完成"
    },
    // 移动端
    paymentOrder: "支付订单",
    payImmediately: "立即支付",
    Alipay: "支付宝",
    wechat: "微信",
    alipayScanCodePayment: "支付宝扫码支付",
    weChatScanCodePayment: "微信扫码支付",
    paymentCompleted: "支付完成",
    paymentText3: "支付完成后，点击以上按钮",
    paymentText4: "正在查询支付结果。。。"
  },

  // 充值页面
  recharge: {
    "选择您的遥控器": "选择您的遥控器",
    "选择您的无人机": "选择您的无人机"
  },

  // 弹框内文字
  confirmText: {
    submitBtn: "确定", // 确定按钮文字
    cancelBtn: "取消", // 取消按钮文字
    prompt: "提示",
    warn: "警告",
    success: "成功",
    sensitiveOperationPrompts: "敏感操作提示",
    loginWasSuccessful: "注册成功",
    loginHasFailed: "注册失败",
    confirmText1: "此操作将删除该地址, 是否继续?",
    confirmText2: "请选择一个收货地址！",
    confirmText3: "未获取到商品信息",
    confirmText4: "订单提交失败！",
    confirmText5: "请完善收货人姓名",
    confirmText6: "请完善收货人联系方式",
    confirmText7: "请完善收货行政区",
    confirmText8: "请完善详细收货地址",
    confirmText9: "未输入手机号码或手机号不正确",
    confirmText10: "即将取消该笔订单, 是否继续?",
    confirmText11: "即将确认签收该笔订单, 是否继续?",
    confirmText12: "请输入手机号和验证。",
    confirmText13: "请输入手机号。",
    confirmText14: "请输入正确格式的手机号",
    confirmText15: "请填写密码",
    confirmText16: "请填写手机验证码",
    confirmText17: "请阅读并同意《用户注册协议》",
    confirmText18: "请输入用户名和密码",
    confirmText19: "取消收藏成功",
    confirmText20: "取消收藏时出现未知错误，请稍后重试",
    confirmText21: "该商品已删除",
    confirmText22: "至少要选择一个购物车商品才能进行支付！",
    confirmText23: "收藏成功",
    confirmText24: "加入购物车成功！",
    confirmText25: "请先选择单品",
    confirmText26: "请输入您的企业名称",
    confirmText27: "请输入您或者企业联系方式",
    confirmText28:
      "提交成功, 我们已收到您提交的信息。我们会安排人员尽快联系您。",
    confirmText29: "提交失败，请联系管理员。",
    confirmText30: "请选择一种付款方式",
    confirmText31: "获取二维码时出现未知错误！",
    confirmText32: "已取消收藏",
    confirmText33: "查询结果为空",
    confirmText34: "登录失败",

    // 移动端
    confirmCancel: "确认取消",
    confirmReceipt: "确认收货",
    mConfiemText1: "该操作会将该笔订单作废，且无法再发起支付，要继续吗？",
    mConfiemText2: "即将签收该笔订单，且该操作不可逆, 是否继续?",
    mmConfiemText3: "该功能还未上线，敬请期待",
    mmConfiemText4: "已退出登录",
    mmConfiemText5: "未知错误,请刷新重试",
    mmConfiemText6: "详细地址不能为空",
    mmConfiemText7: "请选择所在行政区",
    mConfiemText8: "头像修改成功,重新登录后生效。",
    "取消订单成功!": "取消订单成功!",
    "出现一个未知错误，请尝试刷新后重试。":
      "出现一个未知错误，请尝试刷新后重试。",
    "确认收货!": "确认收货!",
    "签收成功!": "签收成功!"
  },
  bindPhone: {
    "绑定手机号": "绑定手机号",
    "账号信息": "账号信息"
  },
  deviceManage: {
    "设备流量管理": "设备流量管理",
    "我的设备": "我的设备",
    "详情": "详情"
  },



};



// WEBPACK FOOTER //
// ./src/components/language/zh.js